__turbopack_context__.v({
  "card": "message-cards-module-scss-module__PVoKDq__card",
  "cardBody": "message-cards-module-scss-module__PVoKDq__cardBody",
  "cardsGrid": "message-cards-module-scss-module__PVoKDq__cardsGrid",
  "cardsWrapper": "message-cards-module-scss-module__PVoKDq__cardsWrapper",
  "imageWrapper": "message-cards-module-scss-module__PVoKDq__imageWrapper",
  "kod": "message-cards-module-scss-module__PVoKDq__kod",
  "meta": "message-cards-module-scss-module__PVoKDq__meta",
  "price": "message-cards-module-scss-module__PVoKDq__price",
  "title": "message-cards-module-scss-module__PVoKDq__title",
});
